import axios from 'axios';
import _ from 'lodash';
import store from '../store';

interface PageMenu { path: string, name: string }
export class RolesService {
  static allRoles: any;
  private static navMenuByRole: { [role: string]: (PageMenu | { groupName: string, pages: PageMenu[] })[] } = {
    "ACCOUNTING_COSTING": [
      {
        "name": "Dashboard",
        "path": "sales-dashboard"
      },
      {
        "name": "Customer",
        "path": "customers"
      },
      {
        "name": "Product",
        "path": "product-master"
      },
      {
        "name": "Quotation",
        "path": "quotation-master"
      }
    ],
    "ACCOUNTING_EXECUTIVE": [
      {
        "name": "Dashboard",
        "path": "accounts-dashboard"
      },
      {
        "groupName": "Reports",
        "pages": [
          {
            "name": "Receivables Aging",
            "path": "aging-report"
          },
          {
            "name": "Statement Of Account ",
            "path": "statement-of-account"
          },
          {
            "name": "Daily VAT Report",
            "path": "daily-vat-report"
          }
        ]
      },
      {
        "name": "Create Credit Note",
        "path": "create-credit-note"
      },
      {
        "name": "Miscellaneous Invoices",
        "path": "misc-invoices"
      },
      {
        "name": "Month Closing",
        "path": "month-closing"
      }
    ],
    "ACCOUNTING_MANAGER": [
      {
        "name": "Dashboard",
        "path": "accounts-dashboard"
      },
      {
        "groupName": "Reports",
        "pages": [
          {
            "name": "Receivables Aging",
            "path": "aging-report"
          },
          {
            "name": "Statement Of Account ",
            "path": "statement-of-account"
          },
          {
            "name": "Daily VAT Report",
            "path": "daily-vat-report"
          }
        ]
      },
      {
        "name": "Create Credit Note",
        "path": "create-credit-note"
      },
      {
        "name": "Miscellaneous Invoices",
        "path": "misc-invoices"
      },
      {
        "name": "Month Closing",
        "path": "month-closing"
      },
      {
        "name": "Currency Exchange",
        "path": "currency-exchange"
      }
    ],    
    "COMMERCIAL_MANAGER": [
      {
        "name": "Purchase Orders",
        "path": "purchasing-order-admin"
      },
      {
        "name": "Create RM/ORM PO",
        "path": "add-purchase-order"
      },
      {
        "name": "Add Spare Parts PO",
        "path": "add-spare-parts-purchase-order"
      },
      {
        "name": "Supplier Master",
        "path": "suppliers"
      },
      {
        "name": "Groups",
        "path": "commercial-groups"
      },
      {
        "name": "Create Spare Parts Transfer",
        "path": "create-spare-part-transfer"
      },
      {
        "name": "Goods",
        "path": "goods"
      },
      {
        "name": "Sales RM Alias",
        "path": "sales-rm-aliases"
      },
      {
        "name": "Spare Parts Master",
        "path": "spare-parts"
      },
      {
        "name": "Receive Spare Parts",
        "path": "spare-parts-receipt"
      }
    ],
    "COMMERCIAL_PURCHASER": [
      {
        "name": "Dashboard",
        "path": "purchase-order"
      },
      {
        "name": "Create RM/ORM PO",
        "path": "add-purchase-order"
      },
      {
        "name": "Add Spare Parts PO",
        "path": "add-spare-parts-purchase-order"
      },
      {
        "name": "Create Spare Parts Transfer",
        "path": "create-spare-part-transfer"
      },
      {
        "name": "Goods",
        "path": "goods"
      },
      {
        "name": "Spare Parts Master",
        "path": "spare-parts"
      },
      {
        "name": "Receive Spare Parts",
        "path": "spare-parts-receipt"
      }
    ],
    "CUSTOMER_SERVICE_ARTWORK": [
      {
        "name": "Production Order",
        "path": "production-order"
      },
      {
        "name": "Product",
        "path": "product-master"
      }
    ],
    "CUSTOMER_SERVICE_INBOUND_WAREHOUSE": [
      {
        "name": "Material Stock",
        "path": "material-stock"
      },
      {
        "name": "Closing Inventory",
        "path": "closing-inventory"
      },
      {
        "name": "Internal Material Transfer",
        "path": "goods-transfer-requests"
      },
      {
        "name": "RM Receipt",
        "path": "rm-receipt"
      },
      {
        "groupName": "Reports",
        "pages": [
          {
            "name": "Trading Order Out",
            "path": "trading-order-out"
          }
        ]
      }
    ],
    "CUSTOMER_SERVICE_MANAGER": [
      {
        "name": "Dashboard",
        "path": "customer-service-dashboard"
      },
      {
        "name": "Call Off",
        "path": "calloff-master"
      },
      {
        "name": "Loading Manifest",
        "path": "loading-manifest-view"
      },
      {
        "name": "Internal Material Transfer",
        "path": "goods-transfer-requests"
      },
      {
        "name": "Material Stock",
        "path": "material-stock"
      },
      {
        "name": "Quotation",
        "path": "quotation-master"
      },
      {
        "name": "Production Order",
        "path": "production-order"
      },
      {
        "name": "Customer",
        "path": "customers"
      },
      {
        "name": "Product",
        "path": "product-master"
      },
      {
        "name": "Sample",
        "path": "sample-master"
      },
      {
        "name": "Complaint",
        "path": "complaint-master"
      },
      {
        "groupName": "Reports",
        "pages": [
          {
            "name": "Monthly Product Expectation",
            "path": "monthly-product-status"
          },
          {
            "name": "Order Out",
            "path": "order-out"
          },
          {
            "name": "Trading Order Out",
            "path": "trading-order-out"
          },
          {
            "name": "Statement Of Account ",
            "path": "statement-of-account"
          }
        ]
      }
    ],
    "CUSTOMER_SERVICE_OUTBOUND_WAREHOUSE": [
      {
        "name": "Production Order",
        "path": "production-order"
      },
      {
        "name": "Internal Material Transfer",
        "path": "goods-transfer-requests"
      },
      {
        "name": "Loading Manifest",
        "path": "loading-manifest-view"
      },
      {
        "name": "Customer",
        "path": "customers"
      },
      {
        "name": "Material Stock",
        "path": "material-stock"
      },
      {
        "name": "Closing Inventory",
        "path": "closing-inventory"
      }
    ],
    "GENERAL_MANAGER": [
      {
        "groupName": "Sales",
        "pages": [
          {
            "name": "Dashboard",
            "path": "sales-dashboard"
          },
          {
            "name": "Customer",
            "path": "customers"
          },
          {
            "name": "Product",
            "path": "product-master"
          },
          {
            "name": "Sample",
            "path": "sample-master"
          },
          {
            "name": "Quotation",
            "path": "quotation-master"
          },
          {
            "name": "Payment",
            "path": "sales-payments"
          },
          {
            "name": "Complaint",
            "path": "complaint-master"
          },
          {
            "name": "Forecast",
            "path": "sales-forecast"
          },
          {
            "name": "Groups",
            "path": "sales-groups"
          }
        ]
      },
      {
        "groupName": "Reports",
        "pages": [
          {
            "name": "Sales Aging",
            "path": "aging-report"
          },
          {
            "name": "Statement Of Account ",
            "path": "statement-of-account"
          },
          {
            "name": "Order Out",
            "path": "order-out"
          },
          {
            "name": "Monthly Sales Expectation",
            "path": "monthly-sales-status"
          },
          {
            "name": "Monthly Product Expectation",
            "path": "monthly-product-status"
          },
          {
            "name": "Open Quotations",
            "path": "open-quotations"
          },
          {
            "name": "Closed Quotations",
            "path": "closed-quotations"
          },
          {
            "name": "Sales Collection",
            "path": "sales-collection"
          },
          {
            "name": "Group Sales Comparison",
            "path": "group-sales-comparison"
          },
          {
            "name": "Group Sales Variance",
            "path": "group-sales-variance"
          }
        ]
      },
      {
        "name": "Miscellaneous Invoices",
        "path": "misc-invoices"
      },
      {
        "name": "Currency Exchange",
        "path": "currency-exchange"
      }
    ],
    "HR_MANAGER": [],
    "PRODUCTION_MANAGER": [
      {
        "name": "Dashboard",
        "path": "ft-dashboard"
      },
      {
        "name": "Production Order",
        "path": "production-order"
      },
      {
        "name": "Sample",
        "path": "sample-master"
      },
      {
        "name": "Complaint",
        "path": "complaint-master"
      },
      {
        "name": "FG Transfer",
        "path": "fg-transfer"
      },
      {
        "name": "RM Transfer",
        "path": "rm-transfer"
      },
      {
        "name": "WIP Transfer",
        "path": "wip-transfer"
      },
      {
        "groupName": "Reports",
        "pages": [
          {
            "name": "Monthly Product Expectation",
            "path": "monthly-product-status"
          },
          {
            "name": "Production Report Summary",
            "path": "production-report-summary"
          }
        ]
      },
      {
        "name": "Operator",
        "path": "create-operator"
      },
      {
        "name": "Machines",
        "path": "machines"
      }
    ],
    "PRODUCTION_OPERATOR": [
      {
        "name": "Operator View",
        "path": "operator-view"
      },
      {
        "name": "My Production Reports",
        "path": "my-production-reports"
      },
      {
        "name": "Production Report",
        "path": "production-report"
      }
    ],
    "PRODUCTION_PLANNER": [
      {
        "name": "Dashboard",
        "path": "ft-dashboard"
      },
      {
        "name": "Production Order",
        "path": "production-order"
      },
      {
        "name": "Create Factory Ticket",
        "path": "factory-ticket"
      },
      {
        "name": "FG Transfer",
        "path": "fg-transfer"
      },
      {
        "name": "RM Transfer",
        "path": "rm-transfer"
      },
      {
        "name": "WIP Transfer",
        "path": "wip-transfer"
      },
      {
        "name": "Print Zebra Label",
        "path": "print-zebra-label"
      }
    ],
    "QA_MANAGER": [
      {
        "name": "Dashboard",
        "path": "quality-dashboard"
      },
      {
        "name": "Product",
        "path": "product-master"
      },
      {
        "name": "Sample",
        "path": "sample-master"
      },
      {
        "name": "Certificate",
        "path": "certificate"
      },
      {
        "name": "Complaint",
        "path": "complaint-master"
      },
      {
        "name": "Internal Material Transfer",
        "path": "goods-transfer-requests"
      },
      {
        "name": "Customer",
        "path": "customers"
      },
      {
        "name": "Quotation",
        "path": "quotation-master"
      }
    ],
    "QA_TECHNICAL_EXECUTIVE": [
      {
        "name": "Dashboard",
        "path": "quality-dashboard"
      },
      {
        "name": "Product",
        "path": "product-master"
      },
      {
        "name": "Sample",
        "path": "sample-master"
      },
      {
        "name": "Certificate",
        "path": "certificate"
      },
      {
        "name": "Complaint",
        "path": "complaint-master"
      }
    ],
    "QA_QUALITY_EXECUTIVE": [
      {
        "name": "Dashboard",
        "path": "quality-dashboard"
      },
      {
        "name": "Certificate",
        "path": "certificate"
      },
      {
        "name": "Product",
        "path": "product-master"
      },
      {
        "name": "Sample",
        "path": "sample-master"
      },
      {
        "name": "Complaint",
        "path": "complaint-master"
      }
    ],
    "SALES_ACCOUNT_EXECUTIVE": [
      {
        "name": "Dashboard",
        "path": "sales-dashboard"
      },
      {
        "name": "Customer",
        "path": "customers"
      },
      {
        "name": "Product",
        "path": "product-master"
      },
      {
        "name": "Sample",
        "path": "sample-master"
      },
      {
        "name": "Quotation",
        "path": "quotation-master"
      },
      {
        "name": "Payment",
        "path": "sales-payments"
      },
      {
        "name": "Complaint",
        "path": "complaint-master"
      },
      {
        "name": "Forecast",
        "path": "sales-forecast"
      },
      {
        "groupName": "Reports",
        "pages": [
          {
            "name": "Sales Aging",
            "path": "aging-report"
          },
          {
            "name": "Statement Of Account ",
            "path": "statement-of-account"
          },
          {
            "name": "Monthly Sales Expectation",
            "path": "monthly-sales-status"
          },
          {
            "name": "Open Quotations",
            "path": "open-quotations"
          },
          {
            "name": "Closed Quotations",
            "path": "closed-quotations"
          },
          {
            "name": "Sales Collection",
            "path": "sales-collection"
          },
          {
            "name": "Group Sales Comparison",
            "path": "group-sales-comparison"
          },
          {
            "name": "Group Sales Variance",
            "path": "group-sales-variance"
          }
        ]
      }
    ],
    "SALES_MANAGER": [
      {
        "name": "Dashboard",
        "path": "sales-dashboard"
      },
      {
        "name": "Customer",
        "path": "customers"
      },
      {
        "name": "Product",
        "path": "product-master"
      },
      {
        "name": "Sample",
        "path": "sample-master"
      },
      {
        "name": "Quotation",
        "path": "quotation-master"
      },
      {
        "name": "Payment",
        "path": "sales-payments"
      },
      {
        "name": "Complaint",
        "path": "complaint-master"
      },
      {
        "name": "Forecast",
        "path": "sales-forecast"
      },
      {
        "groupName": "Reports",
        "pages": [
          {
            "name": "Sales Aging",
            "path": "aging-report"
          },
          {
            "name": "Statement Of Account ",
            "path": "statement-of-account"
          },
          {
            "name": "Order Out",
            "path": "order-out"
          },
          {
            "name": "Monthly Sales Expectation",
            "path": "monthly-sales-status"
          },
          {
            "name": "Monthly Product Expectation",
            "path": "monthly-product-status"
          },
          {
            "name": "Open Quotations",
            "path": "open-quotations"
          },
          {
            "name": "Closed Quotations",
            "path": "closed-quotations"
          },
          {
            "name": "Sales Collection",
            "path": "sales-collection"
          },
          {
            "name": "Group Sales Comparison",
            "path": "group-sales-comparison"
          },
          {
            "name": "Group Sales Variance",
            "path": "group-sales-variance"
          }
        ]
      },
      {
        "name": "Groups",
        "path": "sales-groups"
      }
    ],
    "SYSTEM_ADMIN": [
      {
        "path": "users",
        "name": "Users"
      }
    ]
  };

  static async init() {
    try {
      RolesService.allRoles = (await axios.get('/api/v1/users/roles')).data;
      store.commit('setAppData', {
        rolesArray: Object.values(RolesService.allRoles).sort(),
      });
    } catch (error) {
      store.commit('setSnackbar', { serverMessage: 'error in roles', show: true, color: 'error' })
    }
  }

  static getNavMenu(role: string): (PageMenu | { groupName: string, pages: PageMenu[] })[] {
    const staticRoleName = RolesService.getStaticRoleName(role);
    return staticRoleName ? RolesService.navMenuByRole[staticRoleName] : [];
  }

  static getStaticRoleName(role: string): string | undefined {
    return _.findKey(RolesService.allRoles, (obj) => obj == role);
  }
}